<template>
	<div class="w-full max-w-6xl mx-auto px-8 pt-12 pb-20 lg:pt-20">
		<div class="lg:flex md:-mx-6">
			<div class="lg:w-1/2 md:px-6">
				<div
					class="type-1000 font-70 mb-10 md:mb-16 md:type-1200 md:max-w-md"
				>
					<p class="text-secondary">{{ text }}</p>
					<p class="font-70">{{ title }}</p>
				</div>
				<p class="mb-10 text-mono-300">
					{{
						selectionType === 'single'
							? uiCopy.selectOne
							: uiCopy.selectAll
					}}
				</p>
			</div>
			<div class="lg:w-1/2 md:px-6">
				<div class="h-full lg:flex lg:flex-col">
					<ul class="mb-10 md:flex flex-wrap md:-mx-4">
						<Answer
							v-for="(block, index) in answers"
							:key="`${String(id)}-${index}`"
							:index="index"
							:id="`${String(id)}-${index}`"
							:answer="block.answer"
							:selected="selected"
							:description="block.description"
							v-on:select="clickHandler"
						/>
					</ul>
					<div class="flex -mx-2">
						<div class="px-2">
							<button
								class="btn-previous h-full"
								@click="$emit('slide-prev')"
								:aria-label="uiCopy.previous"
							></button>
						</div>
						<div class="px-2 flex-1">
							<button
								class="btn-primary w-full"
								@click="nextHandler"
								:disabled="!selected.length"
							>
								{{ uiCopy.next }}
							</button>
						</div>
					</div>
					<p class="mt-10 md:mt-24">
						{{ privacyNote }}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			selected: [],
		}
	},
	props: {
		activeIndex: {
			type: Number,
		},
		title: {
			type: String,
			required: true,
		},
		text: {
			type: String,
		},
		maxScore: {
			type: Number,
			required: true,
		},
		id: {
			type: Number,
			required: true,
		},
		index: {
			type: Number,
			required: true,
		},
		privacyNote: {
			type: String,
		},
		category: {
			type: String,
			required: true,
		},
		answers: {
			type: Array,
			required: true,
		},
		uiCopy: {
			type: Object,
			required: true,
		},
		selectionType: {
			// expecting following values as the selection type
			validator: function (value) {
				return (
					['single', 'multi', 'multi-noneofabove'].indexOf(value) !== -1
				)
			},
		},
	},
	methods: {
		clickHandler(index) {
			const updateSelected = () => {
				let selected = [...this.selected]
				const answers = this.answers

				let removeSelected = () => {
					let arrIndex = selected.indexOf(index)
					selected.splice(arrIndex, 1)
				}

				var options = {
					single() {
						if (!selected.includes(index)) {
							selected = [index]
						}
					},
					multi() {
						if (!selected.includes(index)) {
							selected.push(index)
						} else {
							removeSelected()
						}
					},
					'multi-noneofabove'() {
						if (answers[index].noneApply) {
							selected = [index]
						} else if (!selected.includes(index)) {
							let last = answers.length - 1
							if (selected.includes(last)) {
								removeSelected()
							}
							selected.push(index)
						} else {
							removeSelected()
						}
					},
				}

				options[this.selectionType]()

				return selected
			}

			this.selected = updateSelected()
		},
		nextHandler() {
			let data = {
				category: this.category,
				index: this.index,
				score: 0,
				maxScore: this.maxScore,
				selectedAnswers: [],
			}
			this.selected.forEach((element) => {
				data.selectedAnswers.push(this.answers[element].answer)
				if (typeof this.answers[element].points === 'number') {
					data.score = data.score + this.answers[element].points
				}
			})

			this.$emit('slide-next', data)
		},
	},
}
</script>
